import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPagination = params => ({
  type: actionTypes.SET_USERS_LIST_PAGINATION,
  payload: params
})
